module.exports = __webpack_public_path__ + "static/img/KY-jlyEng.6e5c55f.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/KY-jlyEng.png
// module id = vWTO
// module chunks = 1